<script setup lang="ts">
import { AkIcon } from '@ankorstore/design-system';
</script>

<template>
  <span class="proven-success-badge">
    <AkIcon symbol="arrow-repeat-check" />
  </span>
</template>

<style lang="scss">
.proven-success-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background-color: theme('colors.success.700');
  aspect-ratio: 1;
  i {
    color: theme('colors.success.500');
  }
}
</style>
